import { createSlice } from '@reduxjs/toolkit';

const workflowSyncSlice = createSlice({
  name: 'workflowSync',
  initialState: {
    pendingCount: 0,
    updateTick: 0,
    approvalCountRefreshTick: 0,
    approvalCountRefreshTriggered: false,
    connectionStatus: 'idle'
  },
  reducers: {
    incrementPending: (state) => {
      state.pendingCount += 1;
      state.approvalCountRefreshTriggered = false;
    },
    consumePending: (state, action) => {
      const n = action.payload ?? 1;
      state.pendingCount = Math.max(0, state.pendingCount - n);
    },
    workflowUpdated: (state) => {
      console.log('Workflow updated event received');
      state.updateTick += 1;
    },
    triggerApprovalCountRefresh: (state) => {
      if (state.approvalCountRefreshTriggered) {
        return;
      }
      state.approvalCountRefreshTriggered = true;
      state.approvalCountRefreshTick += 1;
    },
    setConnectionStatus: (state, action) => {
      state.connectionStatus = action.payload;
    },
    reset: (state) => {
      state.pendingCount = 0;
      state.updateTick = 0;
      state.approvalCountRefreshTick = 0;
      state.approvalCountRefreshTriggered = false;
      state.connectionStatus = 'idle';
    }
  }
});

export const {
  incrementPending,
  consumePending,
  workflowUpdated,
  triggerApprovalCountRefresh,
  setConnectionStatus,
  reset
} = workflowSyncSlice.actions;

export default workflowSyncSlice.reducer;
